import { Variant, VariantGrade } from '@infrab4a/connect';

export interface VariantDTO extends Variant {
  grade: VariantGrade | any;
}
